<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" label-width="90px">
            <el-form-item label="关键字：" prop="keyword">
                <el-input v-model.trim="searchForm.keyword" maxlength="20" placeholder="请输入关键字(限20字)"
                          clearable></el-input>
            </el-form-item>
            <el-form-item label="检测类型：" prop="schemeType">
                <el-select style="width: 100%" v-model="searchForm.schemeType" clearable
                           placeholder="请选择检测类型">
                    <el-option
                            v-for="item in $dictUtils.getDictList('scheme_type')"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="创建时间：" prop="createTime">
                <el-date-picker
                        v-model="searchForm.createTime"
                        clearable
                        style="width: 100%"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="创建人：" prop="createBy">
                <el-select style="width: 100%" v-model="searchForm.createBy" clearable
                           placeholder="请选择创建人">
                    <el-option
                            v-for="item in createByList"
                            :key="item.createBy"
                            :label="item.createByName"
                            :value="item.createBy">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
            <el-form-item class="f_r">
                <el-button v-if="hasPermission('supervise:quality:qualityList:add')" type="primary" size="small"
                           icon="el-icon-plus" @click="addData('add')">新增
                </el-button>
                <el-button v-if="hasPermission('supervise:quality:qualityList:deleteColumn')" type="danger" size="small"
                           icon="el-icon-delete" @click="deleteColumn()">删除
                </el-button>
                <el-button v-if="hasPermission('supervise:quality:qualityList:reset')" size="small"
                           icon="el-icon-refresh-right" @click="reset()">刷新
                </el-button>
            </el-form-item>
        </el-form>
        <div v-if="dataListSelect.length" class="p_all1 Selected">
            已选择 <span>{{ dataListSelect.length }}</span> 项 <span
                class="specialColor" @click="emptyselectData">清空</span>
        </div>
        <el-table
                :data="dataList"
                v-loading="loading"
                @selection-change="selectionChangeHandle"
                size="small" height="100%"
                @sort-change="sortChange"
                class="table" ref="multipleTable" row-key='id' border>
            <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="schemeName" label="检测方案" show-overflow-tooltip></el-table-column>
            <el-table-column prop="newSchemeType" label="检测类型" show-overflow-tooltip></el-table-column>
            <el-table-column prop="schemeState" label="状态" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <el-switch
                            v-model="row.schemeState"
                            active-value="1"
                            @change="setType(row)"
                            inactive-value="0">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="updateByName" label="最后修改人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="updateDate" label="最后修改时间" sortable show-overflow-tooltip></el-table-column>
            <el-table-column prop="createByName" label="创建人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createDate" label="创建时间" sortable show-overflow-tooltip></el-table-column>
            <el-table-column
                    fixed="right"
                    min-width="180"
                    label="操作">
                <template slot-scope="scope">
                    <el-button v-if="hasPermission('supervise:quality:qualityList:edit')" type="text" size="small"
                               @click="addData('edit', scope.row)">编辑
                    </el-button>
                    <el-button v-if="hasPermission('supervise:quality:qualityList:deleteColumn')" type="text"
                               size="small"
                               @click="deleteColumn(scope.row)">删除
                    </el-button>
                    <el-button v-show="scope.row.reportNum > 0" v-if="hasPermission('supervise:quality:qualityList:report')" type="text" size="small"
                               @click="report(scope.row)">质量检测报告
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <add-quality ref="addQuality" @refresh="refreshList(1,1)"></add-quality>
        <scheme-list ref="schemeList"></scheme-list>
    </div>
</template>

<script>
import AddQuality from "@/views/modules/supervise/quality/addQuality.vue";
import SchemeList from "@/components/testReport/schemeList.vue";
import QualityInspection from "@/components/qualityInspection/qualityInspection.vue";

export default {
    name: "qualityList",
    components: {SchemeList, AddQuality},
    data() {
        return {
            searchForm: {
                keyword: '',
                schemeType: '',
                createBy: '',
                createTime: [],
                createStartTime: '',
                createEndTime: '',
                current: 1,
                size: 20,
            },
            total: 0,
            createByList: [],

            loading: false,
            dataList: [],
            dataListSelect: [],
        }
    },

    mounted() {
        this.refreshList()
        this.getOtherData()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            if (this.searchForm.createTime && this.searchForm.createTime.length != 0) {
                this.searchForm.createStartTime = this.searchForm.createTime[0]
                this.searchForm.createEndTime = this.searchForm.createTime[1]
            } else {
                this.searchForm.createStartTime = ''
                this.searchForm.createEndTime = ''
            }
            let searchData = JSON.parse(JSON.stringify(this.searchForm))
            this.$delete(searchData,'createTime')
            this.loading = true
            this.$axios(this.api.academic.qualityinspectionList, searchData).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    this.dataList.forEach(item => {
                        let typeName = item.schemeType.split(',')
                        let newSchemeType = []
                        typeName.forEach(item => {
                            if (item == 0) {
                                newSchemeType.push('真实性')
                            }
                            if (item == 1) {
                                newSchemeType.push('完整性')
                            }
                            if (item == 2) {
                                newSchemeType.push('可用性')
                            }
                            if (item == 3) {
                                newSchemeType.push('安全性')
                            }
                        })
                        this.$set(item, 'newSchemeType', newSchemeType.join(','))
                    })
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
        },

        getOtherData() {
            this.$axios(this.api.academic.qualityinspectionCreateByList).then(data => {
                if (data && data.status) {
                    this.createByList = data.data
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1)
        },

        //表格勾选数据
        selectionChangeHandle(val) {
            this.dataListSelect = val
        },

        emptyselectData() {
            this.$refs.multipleTable.clearSelection()
        },

        //切换状态
        setType(row) {
            row.schemeState = row.schemeState == '1' ? '0' : '1' //回显
            this.$axios(this.api.academic.qualityinspectionUpdateById, {
                id:row.id,
                schemeState:row.schemeState == '1' ? '0' : '1',
            }, 'put').then(data => {
                if (data && data.status) {
                    this.$message.success('状态修改成功')
                    this.refreshList('', 1)
                } else {
                    this.$message.error(data.msg)
                    this.refreshList('', 1)
                }
            })
        },

        // 列表排序
        sortChange(column, type) {
            // sort: column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : '')
            console.log(column)
        },

        //typeName add新增 edit编辑
        addData(typeName, row) {
            this.$refs.addQuality.init(typeName, row)
        },

        //删除
        deleteColumn(row) {
            let list = row ? [row] : this.dataListSelect
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let reapet = []
            let ids = list.map(item => {
                if (item.schemeState == 1){
                    reapet.push(item)
                }
                return item.id
            })
            if (reapet.length){
                this.$message.warning('请先禁用后再删除！')
                return
            }
            this.$confirm(`您是否确认删除数据?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.qualityinspectionRemoveById, {ids}, 'delete').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.refreshList('', 1)
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },

        //质量检测报告
        report(row) {
            this.$refs.schemeList.init(row,'qualityList')
        },

    },
}
</script>

<style scoped>
.Selected {
    border: 1px solid #BC2124;
    border-radius: 3px;
    padding: 5px 10px;
    background: rgba(188, 33, 36, .1);

    span {
        color: #BC2124;
    }
}

.specialColor {
    margin-left: 15px;
    cursor: pointer;
}
</style>